import React from "react";
import styles from "./AboutUsHome.module.css";
import img1 from "../../assets/home/aboutus4.png";
import img2 from "../../assets/home/aboutus5.png";
import img3 from "../../assets/home/aboutus1.png";

const AboutUsHome = () => {
  return (
    <>
      <div className={`container ${styles.contain}`}>
        <div className="row overflow-hidden">
          <div className="col-md-6">
            <p data-aos="slide-right" className={styles.head}>
              ABOUT US
            </p>
            <p data-aos="slide-left" className={styles.heading}>
              Innovation And Excellence Across Industries
            </p>
            <div data-aos="zoom-in">
              <p className={styles.content}>
                SNEW GROUP is a diversified enterprise driven by innovation,
                purpose, and a commitment to excellence across multiple
                industries. Since our inception, we have continuously evolved to
                meet the dynamic demands of the modern world, bringing together
                cutting-edge technology, creative media, efficient logistics,
                impactful events, essential food products, and advanced
                electronics under one powerful umbrella.
              </p>
            </div>
          </div>

          <div className="col-md-6 mt-5 overflow-hidden">
            <div className={styles.row}>
              <div className={`${styles.column} ${styles.col1}`}>
                <img data-aos="zoom-in-right" src={img1} alt="about-1" />
              </div>
              <div className={styles.column}>
                <img data-aos="zoom-in-left" src={img2} alt="about-2" />
                <img data-aos="zoom-in-left" src={img3} alt="about-3" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutUsHome;
